import { logger } from 'logging-utils';
import apiKeySettingsService from '../services';
import {
  clearErrorMessage,
  setApiKeys,
  setErrorMessage,
  setLoadingApiKeys,
} from '../store-actions/api-keys-store-actions';
import { ApiKeyError } from '../types/api-key-types';

export const loadApiKeys = async () => {
  try {
    setLoadingApiKeys(true);
    clearErrorMessage();

    const apiKeys = await apiKeySettingsService.getApiKeys.execute();
    if (!apiKeys) {
      setErrorMessage(ApiKeyError.FailedLoadApiKeys);
      return;
    }

    setApiKeys(apiKeys);
  } catch (error) {
    logger.error('Failed to get api keys', error);
  } finally {
    setLoadingApiKeys(false);
  }
};
